(() => {
  if (customElements.get('product-form')) {
    return;
  }

  class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('[name="add"]');
      this.cartDrawer = document.querySelector('cart-drawer');
      this.productBar = document.querySelector(
        `#ProductBar-${this.dataset.sectionId}`
      );

      this.form.addEventListener(
        'submit',
        this.onSubmitHandler.bind(this)
      );
    }

    getExtraVariantId() {
      const select = document.getElementById('delivery-timeframe');
      if (!select) return null;

      const option = select.options[select.selectedIndex];
      return option?.dataset?.variantId || null;
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const purchaseOptions = document.querySelector(
        'purchase-options'
      );
      if (
        !!purchaseOptions &&
        !purchaseOptions.isOneTimePurchase() &&
        !this.hasAttribute('data-has-selling-plan')
      ) {
        purchaseOptions.showError();
        return;
      }

      this.submitButton.classList.add('disabled');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      const formData = new FormData(this.form);

      // Get main product variant id
      const mainVariantId = formData.get('id');

      // Collect properties from form
      const properties = {};
      for (let [key, value] of formData.entries()) {
        if (key.startsWith('properties[')) {
          const propName = key.replace('properties[', '').replace(']', '');
          properties[propName] = value;
        }
      }

      // Remove single-item fields
      formData.delete('id');
      formData.delete('quantity');

      // Remove root-level properties (IMPORTANT)
      Object.keys(properties).forEach(prop => {
        formData.delete(`properties[${prop}]`);
      });

      // Add MAIN product
      formData.append('items[0][id]', mainVariantId);
      formData.append('items[0][quantity]', 1);

      // Attach properties to MAIN product
      Object.entries(properties).forEach(([key, value]) => {
        if (value !== "") {
          formData.append(`items[0][properties][${key}]`, value);
        }
      });

      // Add EXTRA / rush-fee product
      const extraVariantId = this.getExtraVariantId();
      if (extraVariantId) {
        formData.append('items[1][id]', extraVariantId);
        formData.append('items[1][quantity]', 1);
      }

      formData.append(
        'sections',
        this.cartDrawer
          .getSectionsToRender()
          .map(section => section.section)
      );
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}.js`, config)
        .then(response => response.json())
        .then(response => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.cartDrawer.renderContents(response);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.submitButton.classList.remove('disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      const errorWrapper = this.querySelector('[data-error-wrapper]');
      if (!errorWrapper) return;

      let message = errorMessage;

      if (typeof errorMessage === 'object' && errorMessage !== null) {
        message = Object.values(errorMessage).flat().join(', ');
      }

      errorWrapper.classList.toggle('hidden', !message);
      errorWrapper.textContent = message || '';
    }


    toggleAddButton(disable, text) {
      [
        this.submitButton,
        this.productBar?.querySelector('[name="add"]')
      ].forEach(submitButton => {
        if (disable) {
          submitButton?.setAttribute('disabled', 'disabled');
          if (text && submitButton) submitButton.textContent = text;
        } else if (submitButton) {
          submitButton.removeAttribute('disabled');
          submitButton.textContent = this.hasAttribute(
            'data-has-selling-plan'
          )
            ? window.variantStrings.addSubscriptionToCart
            : window.variantStrings.addToCart;
        }
      });
    }
  }

  customElements.define('product-form', ProductForm);
})();
